<template>
<fr-modal
    :value="historyDialog"
    @cancel="closeDialog()"
    @hidden="closeDialog()"
    :noPaddingBody="true"
    :verticalCentered="false"
    :showFooter="false"
    :xlarge="true"
    :title="title"
>
    <fr-portlet class="m-0 p-2">
        <fr-portlet-header bordered>
            <fr-portlet-heading></fr-portlet-heading>
            <fr-portlet-item>
                <fr-multiselect
                    :options="columnsList"
                    v-model="selectedColumns"
                    @selectedOptions="(val) => selectedColumns = val"
                    multiple
                    :limit="3"
                    placeholder="Search by columns"
                    class="w-100 text-capitalize"
                    style="min-width: 400px"
                    searchable
                />
            </fr-portlet-item>
        </fr-portlet-header>
        <fr-portlet-item>
            <data-table :apiError="apiError" :loading="loader" :dataLength="logs.length" @reCall="getHistory()" class=" table-hover table-sm">
                <template v-slot:header>
                    <tr>
                        <th class="ps-3" style="width: 200px">Date</th>
                        <td>Event</td>
                        <td>Manager</td>
                        <td style="width: 70%"></td>
                    </tr>
                </template>
                <template v-slot:body>
                    <template v-for="log in logs">
                        <template v-if="log.keys.length">
                            <tr v-if="filteredColumnsList(log.keys).length" class="align-middle">
                                <td class="ps-3 ">{{ log.created_at }}</td>
                                <td class="text-capitalize ">{{ log.event }}</td>
                                <td class="">{{ log.manager?.name }}</td>
                                <td class="py-0">
                                    <table class="table table-hover table-sm ">
                                        <tbody>
                                            <template v-for="(key, index) in filteredColumnsList(log.keys)">
                                                 <tr v-if="['attached', 'detached', 'created', 'deleted'].includes(log.event)">
                                                    <td style="width: 30%" class="bg-yellow align-middle text-capitalize"><small>{{ key }}</small></td>
                                                    <td
                                                        style="width: 70%"
                                                        colspan="3"
                                                        class="align-middle"
                                                        :class=" ['attached', 'created'].includes(log.event) ? 'bg-green' :'bg-red'"
                                                    >
                                                        {{ getNestedValue(log.old_value, key.split(' . ')) || '-' }}
                                                    </td>
                                                </tr>
                                                <tr v-else-if="getNestedValue(log.old_value, key.split(' . ')) !== getNestedValue(log.new_value, key.split(' . '))">
                                                    <td style="width: 30%" class="bg-yellow align-middle text-capitalize"><small>{{ key }}</small></td>
                                                    <td style="width: 32%; word-break: break-all;" class="bg-red align-middle">
                                                        <div style="max-height: 400px; overflow-y: auto;word-break: break-all;">
                                                            {{ getNestedValue(log.old_value, key.split(' . ')) || '-' }}
                                                        </div>
                                                    </td>
                                                    <td style="width: 6%" class="align-middle" :rowspan="log.keys.length" v-if="index == 0">
                                                        <i class="fa fa-long-arrow-right" v-if="!index"></i>
                                                    </td>
                                                    <td style="width: 32% " class="bg-green align-middle">
                                                        <div style="max-height: 400px; overflow-y: auto;word-break: break-all;">
                                                            {{  getNestedValue(log.new_value, key.split(' . ')) || '-' }}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td class="ps-3">{{ log.created_at }}</td>
                            <td class="text-capitalize">{{ log.event }}</td>
                            <td class="text-capitalize">{{ log.manager?.name }}</td>
                            <td :class=" ['attached', 'created'].includes(log.event) ? 'bg-green' :'bg-red'">
                                {{ log.old_value }}
                            </td>
                        </tr>
                    </template>
                </template>
            </data-table>
        </fr-portlet-item>
    </fr-portlet>     
</fr-modal>
</template>
<script>
import {
    FrPortlet,
    FrPortletHeader,
    FrPortletHeading,
    FrPortletItem,
    FrModal,
    FrMultiselect,
} from "@froogal.ai/ui"
import DataTable from "@/components/Table.vue"
import { client, urls } from "@/apiClient"
export default {
    name: 'history-modal',
    components: {
    //     FrPortlet,
    //     FrPortletHeader,
    //     FrPortletHeading,
    //     FrPortletItem,
        FrModal,
    //     FrMultiselect,
        DataTable
    },
    props: [ 'activityId', 'activity' ],
    data() {
        return {
            logs: [],
            historyDialog: false,
            id: '',
            activityInstance: '',
            title: '',
            originalValue: {},
            selectedColumns: [],
            relations: [],
            loader: true,
            apiError: false
        }
    },
    computed: {
        columnsList() {
            return ([...(new Set( this.logs.map(ele => ele.keys).flat().map(ele => ele.join(' . ')) ))])
        }
    },
    mounted() {
        this.showLogs(this.activityId, this.activity);
    },
    methods: {
        showLogs(id, activity ) {
            this.id = id;
            this.activityInstance= activity;
            this.logs = []
            this.relations = [];
            this.getHistory();
            this.historyDialog = true;
        },
        closeDialog() {
            this.historyDialog = false;
            this.logs = []
            this.id ='';
            this.activityInstance = '';
            this.title = '';
            this.relations = [];
            this.selectedColumns = [];
            this.$emit('onClose');
        },
        getHistory() {
            this.loader = true;
            this.apiError = false;
            const request = {
                params: {
                    id: this.id,
                    activity: this.activityInstance
                }
            };
            client.get(urls.getHistoryUrl, request).then(response => {
                this.loader = false;
                this.apiError = false;
                this.originalValue = response.data.data;
                this.title = 'LOGS - ' + this.originalValue.name ;
                this.relations = response.data.relations;
                this.setNewValues( response.data.history)
            }).catch(error => {
                this.apiError = true;
                // this.$toast(error.response?.data?.message, 'Something went wrong!');
            })
        },
        extractNestedKeys(obj, parentKeys = []) {
            let keys = [];
            Object.keys(obj).forEach(key => {
                const newPath = [...parentKeys, key]; // Append the current key to the path
                if(typeof obj[key] === 'string') {
                    try {
                        obj[key] = JSON.parse(obj[key]);
                    } catch (e) {

                    }
                }

                if (!Array.isArray(obj[key]) && typeof obj[key] === 'object' && obj[key] !== null) {
                    // Recursively extract nested keys
                    keys = keys.concat(this.extractNestedKeys(obj[key], newPath));
                } else {
                    // Push the complete key path
                    keys.push(newPath);
                }
            });
            return keys;
        },
        setNewValues(history) {
            let logs = history.map(ele => {
                let keys = ele.old_value && typeof ele.old_value == 'object' ? this.extractNestedKeys(ele.old_value) : []
                return {
                    ...ele,
                    new_value: null,
                    keys: keys
                }
            });
            let HistoryObject = { ...this.originalValue };
            const getNewValue = (oldObject, keys) => {
                if(keys.length) {
                    let newObject = {};
                    keys.forEach(field => {
                        if( Array.isArray(field) ) {
                            this.setNestedValue(newObject, field, this.getNestedValue(HistoryObject, field ));
                            this.setNestedValue(HistoryObject, field, this.getNestedValue(oldObject, field ));
                        } else {
                            newObject[field] = HistoryObject[field];
                            HistoryObject[field] = oldObject[field];
                        }
                    })
                    return newObject;
                } else {
                    return null;
                }
            }
            this.logs = logs.map((ele, index) => {
                return {
                    ...ele,
                    new_value: getNewValue(ele.old_value, ele.keys)
                }
            })
        },
        filteredColumnsList(columns) {
            const fields = columns.map(e => e.join(' . '));
            return this.selectedColumns.length ?
                fields.filter(ele => this.selectedColumns.includes(ele))
                : fields;
        },
        camelToSnake(str) {
            return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
        },
        getNestedValue(obj, dataKeys) {
            if( Array.isArray(dataKeys) ) {
                let keys = [...dataKeys];
                const lastKey = keys.pop();
                const target = keys.reduce((o, key) => o?.[key] || o?.[this.camelToSnake(key)] || {}, obj);
                
                if (target && lastKey in target) {
                    return target[lastKey] ?? null;
                }
            } else {
                return obj[dataKeys];
            }   
        },
        setNestedValue(obj, keys, value) {
            let current = obj;
            keys.slice(0, -1).forEach((key) => {
                if (!current[key] || typeof current[key] !== 'object') {
                    current[key] = {}; // Create parent keys if they don't exist
                }
                current = current[key]; // Move deeper
            });

            // Set or replace the final value
            current[keys[keys.length - 1]] = value;

            return obj; // Return updated object
        }
    }
}
</script>
<style scoped>
.bg-yellow {
    background-color: rgb(254, 254, 218);
}
.bg-red {
    background-color: rgb(253, 225, 225);
}
.bg-green {
    background-color: rgb(227, 255, 227);
}
</style>